import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import './Auth.css';
import logo from '../../assets/Logo - Side.png';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus('error');
      setError('Invalid verification link');
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/saas/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });

      const data = await res.json();

      if (res.ok) {
        setStatus('success');
        localStorage.removeItem('pendingVerification');
        
        // Auto-redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setStatus('error');
        setError(data.error || 'Verification failed');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setStatus('error');
      setError('An error occurred during verification');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Link to="/">
          <img src={logo} alt="RentafAI" className="auth-logo" style={{ display: 'block', margin: '0 auto 24px' }} />
        </Link>

        {status === 'verifying' && (
          <div className="verify-pending">
            <div className="verify-icon">⏳</div>
            <h1>Verifying Your Email...</h1>
            <p>Please wait while we verify your email address.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-success">
            <div className="success-icon">✓</div>
            <h1>Email Verified!</h1>
            <p>
              Your email has been successfully verified.<br />
              You can now log in to your account.
            </p>
            <p style={{ color: '#94a3b8', fontSize: '14px' }}>
              Redirecting to login in 3 seconds...
            </p>
            <Link to="/" className="btn btn-primary btn-block" style={{ marginTop: '24px' }}>
              Go to Login
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-pending">
            <div className="verify-icon">❌</div>
            <h1>Verification Failed</h1>
            <p style={{ color: '#ef4444' }}>{error}</p>
            <p>
              The verification link may have expired or is invalid.<br />
              Please try signing up again or contact support.
            </p>
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <Link to="/signup" className="btn btn-outline" style={{ flex: 1 }}>
                Sign Up
              </Link>
              <Link to="/" className="btn btn-primary" style={{ flex: 1 }}>
                Login
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
